"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.global = exports.formulas = void 0;
const definitions_1 = require("./definitions");
exports.formulas = {
    ...definitions_1.DATE_TRANSLATIONS,
    ...definitions_1.CONDITIONAL_TRANSLATIONS,
    ...definitions_1.STRING_TRANSLATIONS,
    ...definitions_1.MATH_TRANSLATIONS,
    ...definitions_1.WINDOW_TRANSLATIONS,
};
exports.global = {
    booleans: {
        TRUE: 'VERDADEIRO',
        FALSE: 'FALSO',
    },
};
